"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const extractAll_1 = tslib_1.__importDefault(require("./extractAll"));
const atMention_1 = require("./patterns/atMention");
exports.default = (input, opts) => {
    const extracted = extractAll_1.default(input, atMention_1.atMention);
    if (opts && opts.removeAt) {
        return extracted.map((item) => item.replace('@', ''));
    }
    return extracted;
};
